module.exports = __webpack_public_path__ + "static/media/uniswap.b55ea6b2.svg";